import { Layout } from '@/components/layout';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Star, Quote, Instagram, CheckCircle, Image } from 'lucide-react';

const reviews = [
  {
    id: 1,
    name: 'Santosh Kumar',
    location: 'Siliguri, West Bengal',
    rating: 5,
    review: 'Finally found a store I can trust! The whey protein I bought had proper seal and authenticity code. Verified it on the brand website. Will definitely buy again.',
    date: '2 weeks ago',
    verified: true,
    product: 'ON Gold Standard Whey',
  },
  {
    id: 2,
    name: 'Bikash Thapa',
    location: 'Kathmandu, Nepal',
    rating: 5,
    review: 'Ordered from Nepal and received within 5 days. Product was genuine ON Gold Standard with proper hologram. Amazing service and the team kept me updated throughout!',
    date: '1 month ago',
    verified: true,
    product: 'Creatine Monohydrate',
  },
  {
    id: 3,
    name: 'Amit Roy',
    location: 'Jalpaiguri, West Bengal',
    rating: 5,
    review: 'The staff really knows their stuff. I was confused between different pre-workouts and they recommended the perfect one for my training style. Seeing great results!',
    date: '3 weeks ago',
    verified: true,
    product: 'C4 Pre-Workout',
  },
  {
    id: 4,
    name: 'Prakash Magar',
    location: 'Darjeeling, West Bengal',
    rating: 5,
    review: 'Been buying from NutraFuel for 2 years now. Never had a single issue with authenticity. The prices are competitive and the service is exceptional. Highly recommended!',
    date: '1 week ago',
    verified: true,
    product: 'MuscleBlaze Whey',
  },
  {
    id: 5,
    name: 'Rajan Sharma',
    location: 'Gangtok, Sikkim',
    rating: 5,
    review: 'Visited their Siliguri store during my trip. Impressed by the range of products and knowledge of staff. Got my Mass Gainer at a great price with free shaker!',
    date: '2 weeks ago',
    verified: true,
    product: 'BSN Mass Gainer',
  },
  {
    id: 6,
    name: 'Sunita Rai',
    location: 'Biratnagar, Nepal',
    rating: 5,
    review: 'As a female fitness enthusiast, I was skeptical at first. But the team was very helpful and non-judgmental. Got exactly what I needed for my fitness journey.',
    date: '3 weeks ago',
    verified: true,
    product: 'Whey Isolate',
  },
  {
    id: 7,
    name: 'Dipesh Gurung',
    location: 'Dharan, Nepal',
    rating: 5,
    review: 'Cross-border delivery to Nepal was smooth. Product packaging was excellent and everything arrived in perfect condition. Will order again for sure!',
    date: '1 month ago',
    verified: true,
    product: 'Multivitamin',
  },
  {
    id: 8,
    name: 'Arjun Das',
    location: 'Malda, West Bengal',
    rating: 5,
    review: 'The authenticity guarantee gave me confidence to order online. Received my protein powder with all seals intact. Very happy customer!',
    date: '2 weeks ago',
    verified: true,
    product: 'MyProtein Whey',
  },
];

const stats = [
  { value: '5000+', label: 'Happy Customers' },
  { value: '4.9', label: 'Average Rating' },
  { value: '98%', label: 'Repeat Customers' },
  { value: '100%', label: 'Authentic Products' },
];

const ReviewsPage = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative pt-32 md:pt-40 pb-16 bg-gradient-to-b from-muted/50 to-background">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block text-gold font-semibold text-sm uppercase tracking-wider mb-4">TESTIMONIALS</span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-display font-bold text-foreground leading-tight mb-6">
              Customer Reviews &
              <span className="block text-primary">Testimonials</span>
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              Real feedback from real customers across India & Nepal. Don't just take our word for it.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 p-6 rounded-2xl bg-card border border-border shadow-soft">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-display font-bold text-primary">{stat.value}</div>
                  <div className="text-sm text-muted-foreground">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Grid */}
      <section className="py-16 bg-background">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <Card key={review.id} className="bg-card border-0 shadow-soft hover:shadow-elevated transition-all duration-300 hover:-translate-y-1 flex flex-col">
                <CardContent className="p-6 flex flex-col flex-1">
                  {/* Header */}
                  <div className="flex items-start justify-between mb-4">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                      <span className="text-lg font-bold text-primary">{review.name.charAt(0)}</span>
                    </div>
                    <div className="flex gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`w-4 h-4 ${i < review.rating ? 'fill-gold text-gold' : 'text-muted'}`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Product Tag */}
                  <span className="inline-block self-start text-xs px-3 py-1 rounded-full bg-gold/10 text-gold font-medium mb-3">
                    {review.product}
                  </span>

                  {/* Review */}
                  <p className="text-muted-foreground text-sm leading-relaxed mb-6 flex-1">
                    "{review.review}"
                  </p>

                  {/* Footer */}
                  <div className="flex items-center justify-between pt-4 border-t border-border mt-auto">
                    <div>
                      <p className="font-semibold text-foreground text-sm">{review.name}</p>
                      <p className="text-xs text-muted-foreground">{review.location}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      {review.verified && (
                        <span className="inline-flex items-center gap-1 text-xs text-success font-medium">
                          <CheckCircle className="w-3 h-3" />
                          Verified
                        </span>
                      )}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-20 bg-muted/50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block text-gold font-semibold text-sm uppercase tracking-wider mb-4">SOCIAL PROOF</span>
            <h2 className="section-title text-foreground">Follow Us on Instagram</h2>
            <p className="section-subtitle mx-auto mt-4">
              See more reviews, product updates, and fitness content on our Instagram page.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/tsshzq1q_IMG_2518.jpeg',
              'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/kstpb1vk_IMG_2508.jpeg',
              'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/20fc5tvk_IMG_2513.jpeg',
              'https://customer-assets.emergentagent.com/job_nutrasupply/artifacts/y2gv89am_IMG_2515.jpeg',
            ].map((image, index) => (
              <a
                key={index}
                href="https://www.instagram.com/nutrafuel_supplements"
                target="_blank"
                rel="noopener noreferrer"
                className="group aspect-square rounded-xl overflow-hidden bg-muted relative"
              >
                <img 
                  src={image} 
                  alt={`Instagram post ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-primary/80 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                  <Instagram className="w-10 h-10 text-primary-foreground" />
                </div>
              </a>
            ))}
          </div>

          <div className="text-center mt-8">
            <Button variant="gold" size="lg" asChild>
              <a href="https://www.instagram.com/nutrafuel_supplements" target="_blank" rel="noopener noreferrer">
                <Instagram className="w-5 h-5 mr-2" />
                Follow @nutrafuel_supplements
              </a>
            </Button>
          </div>
        </div>
      </section>

      {/* Share Review CTA */}
      <section className="py-20 hero-gradient">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <Quote className="w-16 h-16 mx-auto text-gold mb-6" />
            <h2 className="text-4xl sm:text-5xl font-display font-bold text-primary-foreground mb-6">
              Share Your Experience
            </h2>
            <p className="text-lg text-primary-foreground/80 mb-8">
              Bought from NutraFuel? We'd love to hear about your experience! Share your review and help others make informed decisions.
            </p>
            <Button variant="gold" size="xl" asChild>
              <a href="https://wa.me/9779824042067?text=Hi!%20I'd%20like%20to%20share%20my%20review%20about%20NutraFuel" target="_blank" rel="noopener noreferrer">
                Share Your Review
              </a>
            </Button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ReviewsPage;
